import { z } from "zod";

export const VoiceActorProvider = z.literal("ELEVENLABS_V4");

export const VoiceActorConfigDto = z.object({
  provider: VoiceActorProvider,
  voiceId: z.string(),
});

export const VoiceActorLanguage = z.object({
  language: z.string(),
  locale: z.string().optional(),
  accent: z.string().optional(),
});

export const VoiceActorMetadata = z.object({
  languages: z.array(VoiceActorLanguage),
  description: z.string().optional(),
  gender: z.string().optional(),
  age: z.string().optional(),
});

export const VoiceActorPreviouslyUsedDto = z.object({
  externalIds: z.string().array(),
});

export const VoiceActorDto = z.object({
  externalId: z.string(),
  name: z.string(),
  metadata: VoiceActorMetadata.nullable(),
  previewSrc: z.string().optional(),
});

export const CreateVoiceActorDto = z.object({
  config: VoiceActorConfigDto,
  isGlobal: z.boolean().default(false),
});

export const UpdateVoiceActorDto = z.object({
  isGlobal: z.boolean().optional(),
});

export type VoiceActorLanguage = z.infer<typeof VoiceActorLanguage>;
export type VoiceActorMetadata = z.infer<typeof VoiceActorMetadata>;
export type VoiceActorPreviouslyUsedDto = z.infer<
  typeof VoiceActorPreviouslyUsedDto
>;
export type VoiceActorDto = z.infer<typeof VoiceActorDto>;
export type CreateVoiceActorDto = z.infer<typeof CreateVoiceActorDto>;
export type UpdateVoiceActorDto = z.infer<typeof UpdateVoiceActorDto>;
export type VoiceActorProvider = z.infer<typeof VoiceActorProvider>;
export type VoiceActorConfigDto = z.infer<typeof VoiceActorConfigDto>;
export type VoiceActorConfig = z.infer<typeof VoiceActorConfigDto>;
